import { ActionSearchDto, useSafetyDeviceSearchApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

export type ActionSearchOptions = {
  options: ActionSearchDto | undefined;
};

export const useActionSearch = ({ options }: ActionSearchOptions) => {
  const { actionSearch } = useSafetyDeviceSearchApi();

  const { data: actions, isLoading } = useCustomQuery(
    { key: "action-search", dto: options as ActionSearchDto },
    () => actionSearch(options as ActionSearchDto),
    { enabled: options !== undefined },
  );

  // TODO REMOVE TEST DATA
  // const actions = actionTestData;
  return { actions, isLoading };
};
